import { render, staticRenderFns } from "./GameAvatarMedia.vue?vue&type=template&id=4c78817a"
import script from "./GameAvatarMedia.vue?vue&type=script&lang=js"
export * from "./GameAvatarMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports